export default "__VITE_ASSET__DlhPp1H3__"